function splitProductCategories(categoryLiteral) {
	if (categoryLiteral) {
		const categories = categoryLiteral
			.split("/")
			.filter(cat => cat && cat.legth !== 0)
			.map((cat, index) => {
				const catIndex = index === 0 ? "" : index + 1;
				return ["item_category" + catIndex, cat];
			});
		return Object.fromEntries(categories);
	} else {
		return {};
	}
}

const GA4_PRODUCT_FIELD_MAPPINGS = {
	brand: "item_brand",
	category: "item_category",
	// this will be overriden durring the product creation when split
	category_id: "item_category_id",
	id: "item_id",
	metric3: "item_stroke_price",
	metric6: "item_weight",
	name: "item_name",
	price: "price",
	quantity: "quantity",
	variant: "item_variant",
	dimension12: "item_on_sale",
	dimension14: "item_volume_pricing",
	dimension15: "item_seller",
	dimension22: "item_other_offers_shown",
	dimension27: "item_offer_type",
	dimension29: "item_strikethrough_price",
	dimension32: "item_energy_label",
	dimension33: "item_recommendation",
	dimension42: "item_subsys",
	dimension61: "item_id2",
	dimension62: "item_unit_size",
	list: "item_list_name",
	recommendation: "item_recommendation",
	shippingCost: "item_shipping",
	position: "index",
	pdpType: "item_pdpType",
	coupon: "coupon",
};
//some events doesn't provide ecomerce product fields, this map is indented to map minimum required fields from tags
const TAG_TO_GAU_FIELD_MAPPINGS = {
	basePrice: "price",
	bettyBundleId: "id",
	brandName: "brand",
	categoryPath: "category",
	variantName: "name",
	subsysNumber: "dimension42",
};

function newObjectFromMapping(fieldMappings, fieldValues) {
	const itemFieldEntries = Object.keys(fieldMappings)
		.map(gauFieldName => {
			const ga4FieldName = fieldMappings[gauFieldName];
			return [ga4FieldName, fieldValues[gauFieldName]];
		})
		.filter(fieldToule => fieldToule[1] !== undefined && fieldToule[1] !== null);
	return Object.fromEntries(itemFieldEntries);
}

function productToItem(product) {
	const item = newObjectFromMapping(GA4_PRODUCT_FIELD_MAPPINGS, product);
	const produtCategories = splitProductCategories(product.category);
	return { ...item, ...produtCategories };
}

function tranformProductsToGA4Items(products) {
	return products.map((product, index) => {
		const item = productToItem(product);
		item.index = index;
		return item;
	});
}

function toAmount(val) {
	if ("number" === typeof val) {
		return val;
	}

	if ("string" === typeof val) {
		return Number(val);
	}

	return 0;
}

function evaluateItemsValue(items) {
	return items.reduce((value, prod) => value + toAmount(prod.price) * toAmount(prod.quantity), 0);
}

function newGa4Event(eventType, products, currencyCode?) {
	const items = tranformProductsToGA4Items(products);
	const ecommerce: any = {
		items: items,
	};

	if (currencyCode) {
		ecommerce.currency = currencyCode;
		ecommerce.value = evaluateItemsValue(items);
	}

	return {
		event: eventType,
		ecommerce,
	};
}

function toGa4Purchase(ecommerce) {
	if (ecommerce.purchase) {
		const event = newGa4Event("purchase", ecommerce.purchase.products || [], ecommerce.currencyCode);
		event.ecommerce.transactionId = ecommerce.purchase.actionField && ecommerce.purchase.actionField.id;
		return event;
	}
}

function getProducts(ecommerce, sectionName) {
	const sectionData = ecommerce[sectionName];
	return sectionData ? sectionData.products : [];
}

export function toGa4Structure(eventType, hiddenData, tags) {
	const ecommerce = (hiddenData && hiddenData.ecommerce) || {};

	switch (eventType) {
		case "basket.add":
			return newGa4Event("add_to_cart", getProducts(ecommerce, "add"), ecommerce.currencyCode);

		case "checkout.page.summary":
			return newGa4Event("begin_checkout", getProducts(ecommerce, "checkout"), ecommerce.currencyCode);

		case "checkout.page.payment":
			return newGa4Event("add_payment_info", getProducts(ecommerce, "checkout"), ecommerce.currencyCode);

		case "checkout.page.delivery":
			return newGa4Event("add_shipping_info", getProducts(ecommerce, "checkout"), ecommerce.currencyCode);

		case "article.productView":
			return newGa4Event("view_item", getProducts(ecommerce, "detail") || [], ecommerce.currencyCode);

		case "order.submit.success.ga360":
			return toGa4Purchase(ecommerce);

		case "article.open":
			return newGa4Event("select_item", [newObjectFromMapping(TAG_TO_GAU_FIELD_MAPPINGS, tags)]);

		default:
			return undefined;
	}
}
